export default "__VITE_ASSET__ecVyHrw0__"